import { cloneDeep, get, isEmpty } from 'lodash';
import moment from 'moment';
import { Toast } from 'antd-mobile';
import * as services from '../services/pointShop';

export default {
  namespace: 'pointShop',
  state: {
    isDXP: true,
    pointDetail: {}, // 积分详情（可用积分）,
    pointAccountsInfo: [], // 多账户积分详情
    catgctList: [], // 兑换商品列表
    faqList: [], // FAQ列表,
    searchOfferList: [], // 搜索结果
    searchOfferParams: {}, // 搜索条件
    searchOfferListTotal: 0,
    changeHis: [], // 积分历史列表,
    pageInfoHis: {},
    pointOrderList: [], // 积分兑换历史
    pointOrderListTotal: 10,
    pointOrderParams: {}, // orderlist查询条件
    allCatgId: '', // 所有的目录id
    smsCode: '', // 输入的验证码
    hasLengthRight: false, // 输入框长度是否符合
    hasGetClick: false, // 按钮是否被触发 true
    hasTimeEnd: true, // 倒计时是否结束 false
    homeContent: {},
    cataList: [], // 首页目录
    currCataId: -1, // 首页默认目录
    pointsList: [], // 包列表
    currPageInfo: {}, // 首页页面信息,
    successOfferInfo: {}, // 代理商积分兑换offer成功之后的信息
    dealerPageInfo: {}, // 代理商积分商城首页广告等配置信息
    selectedArticle: {}, // 代理商积分商城选择的文章obj
    mixedList: [], // 券历史列表
    pointList: [], // 积分历史列表
    pointPageInfo: {},
    pList: [],
    vList: [],
    voucherPageInfo: {},
    pointExchangeRuleList: [],
    pointExchangeRule: {},
    ledgerBalanceDisplay: null,
    ledgerBalanceUnit: null,
    pointExchangeRuleColumn: [[]], // 选择账本的二维数组格式
    pbPageCode: null, // url中配置的pb的pageCode备份，如果没有配置会有一个默认的pageCode
  },

  effects: {
    // 兑换历史
    *queryChangeHisDXP({ payload }, { call, put, select }) {
      let initChangeHis = yield select(({ pointShop }) => pointShop.changeHis);
      if (payload.pageIndex === 1) {
        initChangeHis = [];
      }
      const changeHis = yield call(services.queryChangeHisDXP, payload);
      let pointChangeHisList = get(changeHis, 'data') || [];
      pointChangeHisList = pointChangeHisList.map(item => ({
        ...item,
        pointExchObjName: item.reason,
        date: item.transactionDate,
        amount: item.pointValue,
        ledgerBalanceToPointsName: item.accountBalanceToPointsName,
      }));
      if (get(changeHis, 'resultCode') === '0') {
        yield put({
          type: 'updateState',
          payload: {
            changeHis: [...initChangeHis, ...pointChangeHisList],
            pageInfoHis: {
              pageIndex: changeHis.pageIndex,
              pageSize: changeHis.pageSize,
              totalCount: changeHis.totalCount,
            },
          },
        });
      }
      return changeHis;
    },
    *getPointOrderListDXP({ payload }, { call, put, select }) {
      const result = yield call(services.qryOrderListDXP, payload);
      const total = yield select(state => state.pointShop.pointOrderListTotal);
      let pointOrderList = get(result, 'data') || [];
      if (get(result, 'resultCode') === '0') {
        pointOrderList = pointOrderList.map(item => {
          const finnalItem = {
            ...item,
            accNbr: item.serviceNumber,
            totalAmount: item.totalAmountInt,
            totalAmountDisplay: item.totalAmount,
            feeInfo: {
              ...(item?.feeInfo || {}),
              skuFeeList: (item?.feeInfo?.skuFeeList || []).map(skuFeeItem => ({
                ...skuFeeItem,
                unitPrice: skuFeeItem.unitPriceInt,
                displayUnitPrice: skuFeeItem.unitPrice,
                totalPrice: skuFeeItem.totalPriceInt,
                displayTotalPrice: skuFeeItem.totalPrice,
              })),
            },
            orderSkuList: (item?.orderSkuList || []).map(orderSkuItem => ({
              ...orderSkuItem,
              rentPrice: orderSkuItem.rentPriceInt,
              rentPriceDisplay: orderSkuItem.rentPrice,
              price: orderSkuItem.priceInt,
              priceDisplay: orderSkuItem.price,
            })),
          };
          return finnalItem;
        });
        const pointOrderListTotal =
          get(result, 'totalCount') || get(result, 'data.pageInfo.total') || total;
        yield put({
          type: 'updateState',
          payload: {
            pointOrderList,
            pointOrderListTotal,
            pointOrderParams: payload,
          },
        });
      }
      return {
        ...result,
        data: {
          orderList: pointOrderList,
          pageInfo: {
            pageIndex: result?.pageIndex,
            pageSize: result?.pageSize,
            totalCount: get(result, 'totalCount') || get(result, 'data.pageInfo.total'),
          },
        },
        code: result?.resultCode === '0' ? '200' : '',
      };
    },
    // 获取积分详情
    *getPointDetailDXP({ payload }, { call, put }) {
      const pointDetail = yield call(services.getPointDetailDXP, payload);
      let data = cloneDeep(get(pointDetail, 'data') || {}) || [];
      data = Array.isArray(data)
        ? data.map(item => ({
          ...item,
          totalPoint: item.totalPointInt,
          totalPointDisplay: item.totalPoint,
          usablePoint: item.availablePointInt,
          usablePointDisplay: item.availablePoint,
          usedPoint: item.usedPointInt,
          usedPointDisplay: item.usedPoint,
          expiringPointDisplay: item.expiringPoint,
          expiringPoint: item.expiringPointInt,
        }))
        : [];
      // data = {
      //   ...data,
      //   totalPoint: data.totalPointInt,
      //   totalPointDisplay: data.totalPoint,
      //   usablePoint: data.availablePointInt,
      //   usablePointDisplay: data.availablePoint,
      //   usedPoint: data.usedPointInt,
      //   usedPointDisplay: data.usedPoint,
      //   expiringPointDisplay: data.expiringPoint,
      //   expiringPoint: data.expiringPointInt,
      // };
      // data.latestExpiringPointList = (data.lastExpiringPointList || []).map(item => ({
      //   ...item,
      //   expiringPointDisplay: item.expiringPoint,
      //   expiringPoint: item.expiringPointInt,
      // }));
      if (get(pointDetail, 'resultCode') === '0') {
        yield put({
          type: 'updateState',
          payload: {
            pointDetail: isEmpty(data?.find(item => item.pointAccountTypeCode === '1'))
              ? data?.[0] || []
              : data?.find(item => item.pointAccountTypeCode === '1'),
            pointAccountsInfo: data || [],
          },
        });
      }
      return data;
    },
    *getDealerPageInfoDXP({ payload }, { call, put }) {
      const dealerPageInfo = yield call(services.getDealerPageInfoDXP, payload);
      let data = get(dealerPageInfo, 'data');
      data = {
        promotionEventLink: data,
      };
      if (get(dealerPageInfo, 'resultCode') === '0') {
        yield put({
          type: 'updateState',
          payload: {
            dealerPageInfo: data,
          },
        });
      }
      return data;
    },
    // 获取代理商积分商城faq 文章列表信息
    *qryFaqList({ payload }, { call }) {
      const res = yield call(services.qryFaqList, payload);
      // if (get(dealerPageInfo, 'code') === '200') {
      //   yield put({
      //     type: 'updateState',
      //     payload: {
      //       dealerPageInfo: get(dealerPageInfo, 'data'),
      //     },
      //   });
      // }
      return get(res, 'data') || [];
    },
    // 取预制的差评常用原因列表
    *getNegativeComments({ payload }, { call }) {
      const res = yield call(services.getNegativeComments, payload);
      return get(res, 'data') || [];
    },

    // 评价接口
    *sendWikiComment({ payload }, { call }) {
      try {
        const resp = yield call(services.sendWikiComment, payload);
        const data = get(resp, 'data');
        const code = get(resp, 'retCode');
        const resultMsg = get(resp, 'resultMsg');
        // 0表示成功
        if (code === '200') {
          Toast.show({
            icon: 'success',
            content: get(resp, 'retDesc') || 'Send comment successfully',
          });
          return data;
        }
        Toast.show({ icon: 'fail', content: resultMsg });
        return null;
      } catch (e) {
        Toast.show({ icon: 'fail', content: e.Error });
        return null;
      }
    },

    // 获取商品列表目录
    *getCatgctListDXP({ payload }, { call, put }) {
      let catgctList = yield call(services.getCatgctListDXP, payload) || {};
      // console.log('11111111111ffff', catgctList);
      catgctList = {
        ...catgctList,
        code: catgctList.resultCode === '0' ? '200' : null,
        data: {
          prodCatgList: catgctList?.data?.map(item => ({
            ...item,
            id: item.code,
          })),
        },
      };
      if (!get(catgctList, 'code')) {
        yield put({
          type: 'updateState',
          payload: {
            catgctList,
          },
        });
      }
      return catgctList;
    },

    // // 获取商品列表
    // *getProductList({ payload }, { call }) {
    //   const productList = yield call(services.getProductList, payload);
    //   return productList;
    // },

    // 获取商品详情
    *getProductDetailDXP({ payload }, { call }) {
      const productList = yield call(services.getProductDetailDXP, payload);
      let data = get(productList, 'data') || {};
      data = {
        shopProdDetail: {
          ...data,
          skuList: (data.skuList || []).map(item => ({
            ...item,
            price: item.priceInt,
            priceDisplay: item.price,
            marketPrice: item.marketPriceInt,
            marketPriceDisplay: item.marketPrice,
            pointPrice: item.pointPriceInt,
            pointPriceDisplay: item.pointPrice,
            guidingPrice: item.guidingPriceInt,
            formatGuidingPrice: item.formatGuidingPrice,
          })),
        },
      };
      return data || {};
    },

    // 搜索商品
    *getProductSearchDXP({ payload }, { call }) {
      const result = yield call(services.getProductSearchDXP, payload);
      let data = get(result, 'data') || [];
      data = {
        pointProductList: data.map(item => ({
          ...item,
          id: item.spuNbr,
          isNew: item.isNew ? 'Y' : 'N',
          skuList: (item.skuList || []).map(skuItem => ({
            ...skuItem,
            price: skuItem.priceInt,
            priceDisplay: skuItem.price,
            marketPrice: skuItem.marketPriceInt,
            marketPriceDisplay: skuItem.marketPrice,
            pointPrice: skuItem.pointPriceInt,
            pointPriceDisplay: skuItem.pointPrice,
            guidingPrice: skuItem.guidingPriceInt,
            formatGuidingPrice: skuItem.formatGuidingPrice,
          })),
        })),
        pageInfo: {
          pageIndex: result.pageIndex,
          pageSize: result.pageSize,
          totalCount: result.totalCount,
          hasNextPage: result.hasNextPage,
        },
      };
      return data;
    },

    // 发送手机验证码
    *sendSMSCode({ payload }, { call }) {
      const result = yield call(services.sendSMSCode, payload) || {};
      return result;
    },

    // 兑换积分
    *redeemPointsDXP({ payload }, { call }) {
      let result = yield call(services.redeemPointsDXP, payload);
      result = {
        ...result,
        code: result?.resultCode === '0' ? '200' : null,
        data: {
          ...(result?.data || {}),
          changeBefore: result?.data?.pointChangeBeforeInt,
          changeBeforeDisplay: result?.data?.pointChangeBefore,
          changeAfter: result?.data?.pointChangeAfterInt,
          changeAfterDisplay: result?.data?.pointChangeAfter,
          pointChangeDisplay: result?.data?.pointChange,
          pointChange: result?.data?.pointChangeInt,
        },
      };
      return result;
    },
    *getHomeContentDXP({ payload }, { call }) {
      const res = yield call(services.getHomeContentDXP, payload);
      if (res && res?.resultCode === '0') {
        return res;
      }
      return {};
    },
    *queryUserVoucherInfoListDXP({ payload }, { call, put, select }) {
      const { isRefresh } = payload;
      if (isRefresh) {
        yield put({
          type: 'updateState',
          payload: {
            mixedList: [],
            vList: [],
            VoucherPageInfo: {},
          },
        });
      }
      delete payload.isRefresh;
      const { voucherPageInfo, vList } = yield select(state => state.pointShop);
      const nextPage = isRefresh ? 1 : get(voucherPageInfo, 'currentPage', 0) + 1;
      let res = yield call(services.queryVoucherHistoryListDXP, {
        ...payload,
        pageSize: voucherPageInfo.pageSize || 20,
        // currentPage: nextPage,
        // 请求的页数
        pageIndex: nextPage,
      });
      res = {
        ...res,
        retCode: res.resultCode,
        retDesc: res.resultMsg,
        pageInfo: {
          currentPage: res.pageIndex,
          pageNum: res.pageIndex,
          pageSize: res.pageSize,
          total: res.totalCount,
        },
        data: {
          userVoucherInfoList: (res.data || []).map(item => ({
            ...item,
            voucherInstCode: item.couponInstCode,
            voucherImageUrl: item.couponImageUrl,
            voucherName: item.couponName,
            voucherDesc: item.couponDesc,
            voucherFlag: item.couponState,
          })),
        },
      };
      const retCode = res?.retCode || res?.resultCode || '-1';
      const retDesc = res?.retDesc || res?.resultMsg || null;
      if (Number(retCode) !== 0) {
        yield put({
          type: 'updateState',
          payload: {
            mixedList: [],
            vList: [],
            VoucherPageInfo: {},
          },
        });
        if (!(retCode?.includes('DCM-PROM-000002') || retDesc?.includes('DCM-PROM-000002'))) {
          Toast.show({ icon: 'fail', content: retDesc });
        }
        return;
      }
      const result = res?.data || {};
      const listGroups = {};
      const voucherList = get(result, 'userVoucherInfoList', []);
      const newPageInfo = get(result, 'pageInfo', {});
      const tempList = vList.concat(voucherList);
      tempList.forEach(item => {
        const key = moment(item.credatedDate, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM');
        // 每个月的存储到listgroup
        if (!listGroups[key]) {
          listGroups[key] = {
            list: [],
          };
        }
        listGroups[key].list.push(item);
      });

      const mixedList = [];
      Object.keys(listGroups).forEach(month => {
        const listObj = listGroups[month];
        const { list: cardList } = listObj;
        const isThisMon = moment().isSame(month, 'month');
        const sentry = {
          monthName: isThisMon ? 'This month' : moment(month, 'YYYY-MM').format('MMMM'),
          cardList,
        };
        mixedList.push(sentry);
      });
      yield put({
        type: 'updateState',
        payload: {
          voucherPageInfo: {
            ...newPageInfo,
          },
          // list: payload.isRefresh ? orderList : list.concat(orderList),
          mixedList,
          vList: payload.isRefresh ? voucherList : vList.concat(voucherList),
        },
      });
    },
    *queryPointHistoryDXP({ payload }, { call, put, select }) {
      const { isRefresh } = payload;
      if (isRefresh) {
        yield put({
          type: 'updateState',
          payload: {
            pointList: [],
            pList: [],
            pointPageInfo: {},
          },
        });
      }
      delete payload.isRefresh;
      const { pointPageInfo, pList } = yield select(state => state.pointShop);
      const nextPage = isRefresh ? 1 : get(pointPageInfo, 'currentPage', 0) + 1;
      let res = yield call(services.queryPointHistoryDXP, {
        ...payload,
        pageSize: pointPageInfo.pageSize || 20,
        // currentPage: nextPage,
        // 请求的页数
        pageIndex: nextPage,
      }) || {};
      res = {
        ...res,
        retCode: res.resultCode,
        retDesc: res.resultMsg,
        pageInfo: {
          currentPage: res.pageIndex,
          pageNum: res.pageIndex,
          pageSize: res.pageSize,
          total: res.totalCount,
        },
        data: (res.data || []).map(item => ({
          ...item,
          totalIncreaseAmount: item.totalIncreaseAmountInt,
          totalIncreaseAmountDisplay: item.totalIncreaseAmount,
          totalDecreaseAmount: item.totalDecreaseAmountInt,
          totalDecreaseAmountDisplay: item.totalDecreaseAmount,
          pointAcctHisDtoList: item?.pointChangeList?.map(it => ({
            ...it,
            pointValue: it.pointAmountInt,
            pointValueDisplay: it.pointAmount,
          })),
        })),
      };
      const result = res?.data || {};
      const listGroups = {};
      const newPageInfo = res?.pageInfo;
      const tempList = pList.concat(result);
      tempList.forEach(item => {
        const key = moment(item.month).format('YYYY-MM');
        // 每个月的存储到listgroup
        if (!listGroups[key]) {
          listGroups[key] = {
            list: [],
          };
        }
        listGroups[key].list.push(item);
      });

      const pointList = [];
      Object.keys(listGroups).forEach(month => {
        const listObj = listGroups[month];
        const { list: cardList } = listObj;
        const isThisMon = moment().isSame(month, 'month');
        const sentry = {
          monthName: isThisMon ? 'This month' : moment(month, 'YYYY-MM').format('MMMM'),
          cardList,
        };
        pointList.push(sentry);
      });
      // pointList.reverse();
      yield put({
        type: 'updateState',
        payload: {
          pointPageInfo: {
            ...newPageInfo,
          },
          // list: payload.isRefresh ? orderList : list.concat(orderList),
          pointList,
          pList: payload.isRefresh ? result : pList.concat(result),
        },
      });
    },
    *queryExchangeRule(_, { call, put }) {
      const res = yield call(services.queryExchangeRule);
      const pointExchangeRuleList = (res?.data || []).map(item => ({
        ...item,
        pointValue: item.pointValueInt,
        pointValueDisplay: item.pointValue,
        pointValidDays: item.pointValidPeriod,
        pointValidDaysUnit: item.pointValidDaysUnit,
        key: item.acctResCode,
        label: item.acctResName,
      }));

      const pointExchangeRuleColumn = [
        pointExchangeRuleList.map(item => ({
          value: item.acctResCode,
          label: item.acctResName,
        })),
      ];
      yield put({
        type: 'updateState',
        payload: {
          pointExchangeRuleList,
          pointExchangeRuleColumn,
          pointExchangeRule: pointExchangeRuleList?.length > 0 ? pointExchangeRuleList?.[0] : {},
        },
      });
    },
    *queryLedgerBalance({ payload }, { call, put }) {
      const res = yield call(services.queryLedgerBalance, payload);
      yield put({
        type: 'updateState',
        payload: {
          ledgerBalanceDisplay: res?.data?.accountBalance,
          ledgerBalanceUnit: res?.data?.accountBalanceUnit,
        },
      });
      return {
        ledgerBalanceDisplay: res?.data?.accountBalance,
        ledgerBalanceUnit: res?.data?.accountBalanceUnit,
        productId: res?.data?.productId ?? null,
      };
    },
    *exchangePoints({ payload }, { call }) {
      const res = yield call(services.exchangePoints, payload);
      return res;
    },
    *conversionList({ payload }, { call }) {
      const res = yield call(services.conversionList, payload);
      return res;
    },
    *conversionPoint({ payload }, { call }) {
      const res = yield call(services.conversionPoint, payload);
      return res;
    },
    *transferPointList({ payload }, { call }) {
      const res = yield call(services.transferPointList, payload);
      return res;
    },
    *queryCouponDetail({ payload }, { call }) {
      const res = yield call(services.queryCouponDetail, payload);
      return res.data || {};
    },
    *queryCouponOfferList({ payload }, { call }) {
      const res = yield call(services.queryCouponOfferList, payload);
      return res.data || {};
    },
    *redeemCoupon({ payload }, { call }) {
      const res = yield call(services.redeemCoupon, payload);
      return res.data || {};
    },
    *claimCoupon({ payload }, { call }) {
      const res = yield call(services.claimCoupon, payload);
      return res.data || {};
    },
  },

  reducers: {
    updateState(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
